import { Box, keyframes, useTheme } from "@mui/system"
import { getRandomInt } from "app/tools/common"
import React from "react"

interface IShiningSquareProps {
  sx?: any
}

export const ShiningSquare = React.memo(({ sx }: IShiningSquareProps) => {
  const theme = useTheme()
  const animationDelayInSeconds = getRandomInt(2, 5)
  const changeBackgroundColor = keyframes`
    0% {
      background: ${theme.palette.background.paper};
    }
    50% {
      background: ${theme.palette.special};
    }
    100% {
      background: ${theme.palette.background.paper};
    }`

  return (
    <Box
      sx={{
        width: ".6rem",
        height: ".6rem",
        animation: `${changeBackgroundColor} ${animationDelayInSeconds}s infinite`,
        ...sx
      }}
    />
  )
})
